import { IndexKey } from "tldraw"
import { Color, Expr } from "./Expr"
import { color } from "bun"

export type LayerId = string & { __brand: "LayerId" }

export type LayerProps = {
  id: LayerId
  name: string
  index: IndexKey
  visible: Expr<boolean>
  opacity: Expr<number>
  strokeColorOverride: Expr<Color> | null
  fillColorOverride: Expr<Color> | null
  strokeWidthOverride: Expr<number> | null
  layerOverrides: Record<string, Expr<any> | null>
}

const defaultValues: Omit<LayerProps, "id" | "name"> = {
  visible: Expr.lit(true),
  index: "a1" as IndexKey,
  opacity: Expr.lit(1),
  strokeColorOverride: null,
  fillColorOverride: null,
  strokeWidthOverride: null,
  layerOverrides: { strokeColor: null, fillColor: null, strokeWidth: null },
}

export const Layer: Record<"layer1", LayerProps> = {
  // some default layers

  layer1: {
    ...defaultValues,
    name: "Layer 1",
    id: "layer1" as LayerId,
    index: "a1" as IndexKey,
    layerOverrides: { strokeColor: null, fillColor: null, strokeWidth: null },
  },
}
